/**
  * 商品模块接口列表
  */

 import base from './base'; // 导入接口域名列表
 import axios from './http'; // 导入http中创建的axios实例
 import qs from 'qs'; // 根据需求是否导入qs模块
 
 const commodity = {
     // 新闻列表
     commodityHotList (params) {
         return axios.get(`${base.fm}/store_commodity/hot/list`,{
            params: params
         });
     },
     // 新闻详情,演示
     articleDetail (id, params) {
         return axios.get(`${base.fm}/topic/${id}`, {
             params: params
         });
     },
     // post提交
     login (params) {
         return axios.post(`${base.fm}/accesstoken`, qs.stringify(params));
     },
     pickleballScoreResult(data){
        return axios.post(base.fm+"/store_order/commodity/pickleball_score",data)
     }
     // 其他接口…………
 }
 
 export default commodity;
 


// WEBPACK FOOTER //
// ./src/api/commodity.js